var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo, useContext } from 'react';
import { IntlProvider } from 'react-intl';
import { useExtendedLogger } from '../Logger';
import { Context as LocaleContext } from './LocaleProvider';
import useTranslations from './useTranslations';
import { LOGGER_NAME } from './constants';
var Context = React.createContext(null);
function Provider(_a) {
    var children = _a.children, localeBaseUrl = _a.localeBaseUrl, _b = _a.loader, loader = _b === void 0 ? _jsx(_Fragment, {}, void 0) : _b;
    var log = useExtendedLogger(LOGGER_NAME);
    var currentLanguage = useContext(LocaleContext).currentLanguage;
    var _c = useTranslations(currentLanguage, localeBaseUrl), translations = _c.translations, loading = _c.loading, failed = _c.failed;
    var context = useMemo(function () { return ({
        loading: loading,
        failed: failed,
    }); }, [failed, loading]);
    log('adding translation provider with context %o', context);
    return (_jsx(Context.Provider, __assign({ value: context }, { children: _jsx(IntlProvider, __assign({ locale: currentLanguage, messages: translations }, { children: loading ? loader : children }), void 0) }), void 0));
}
export { Context, Provider };
//# sourceMappingURL=TranslationProvider.js.map